const MULTI_ACT_FORM_NAME = 'multiActForm';

export default MULTI_ACT_FORM_NAME;
